import { Circles } from "react-loader-spinner";

const Loader = ({ loading = false, backgroundColor = "#00000070" }) => {
  if (!loading) return null;
  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000000,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        height: "100%",
        width: "100%",
        background: backgroundColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Circles
        height="80"
        width="80"
        color="#ee6635"
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export default Loader;
